import { Component, OnInit } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-admin-experience-days",
  templateUrl: "./admin-experience-days.component.html",
  styleUrls: ["./admin-experience-days.component.scss"],
  standalone: false,
})
export class AdminExperienceDaysComponent implements OnInit {
  configTable = {
    hasPagination: true,
    columns: [
      {
        header_name: "Title",
        name: "title",
        type: "text",
      },
      {
        header_name: "Description",
        name: "description",
        type: "text",
      },
      {
        header_name: "Status",
        name: "status",
        type: "text",
      },
      {
        header_name: "Company",
        name: "company",
        subName: "name",
        type: "text",
      },
      {
        header_name: "Possible dates",
        name: "possibleDates",
        subName: "name",
        type: "array",
      },
      {
        header_name: "Amount registrations",
        name: "numberOfRegistrations",
        type: "text",
      },
      {
        header_name: "Min. students",
        name: "minStudents",
        type: "text",
      },
      {
        header_name: "Max. students",
        name: "maxStudents",
        type: "text",
      },
    ],
    endpoint: "experienceday",
    data: <any>[],
    buttons: <any>[],
    class: "",
    reloadListener: new Subject(),
    queryParams: [],
  };

  ngOnInit(): void {}
}
